import { Injectable } from '@angular/core';
import { Area } from '../../resources/area/area.interface';
import { Cluster } from '../../resources/cluster/cluster.interface';
import { Building } from '../../resources/building/building.interface';

/**
 * Flooar area service.
 *
 * Used to calculate the BVO / FNO ratios.
 */
@Injectable({
  providedIn: 'root'
})
export class FloorAreaService {

  constructor() { }

  /**
   * Get FNO for an area.
   *
   * @param area The area to calculate the FNO for.
   * @returns Total FNO for the area.
   */
  public getAreaFNO(area: Area): number {
    return area.surface * area.quantity;
  }

  /**
   * Get the total FNO for a building.
   *
   * @param building The building to calculate the FNO for.
   * @returns Total FNO for the building.
   */
  public getBuildingFNO(building: Building): number {
    let fno = 0;
    for (const cluster of building.clusters) {
      fno += this.getClusterFNO(cluster);
    }
    return fno;
  }

  /**
   * Get the total FNO for a cluster.
   *
   * @param cluster The cluster to calculate the FNO for.
   * @returns Total FNO for the cluster.
   */
  public getClusterFNO(cluster: Cluster): number {
    let fno = 0;
    for (const area of cluster.areas.filter(a => a.active && a.functionality === 1)) {
      fno += this.getAreaFNO(area);
    }
    return fno;
  }
}
